import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import AuthLayout from '@/screens/Auth'
import BaseLayout from '../layout/components/BaseLayout'
import Home from '../screens/Home/Home'
import Layout from '../layout'
import PBFLayout from '@/screens/Order'
import QSFLayout from '@/screens/QSF'
import UserProfile from '@/screens/UserProfile/UserProfile'
import LiveboardLayout from '@/screens/Liveboard'
import SystemConfigure from '@/screens/SystemConfigure'
import LoadingPage from '@/components/LoadingPage/LoadingPage'
import TasksLayout from '@/screens/Tasks'
import ExportDataLayout from '@/screens/ExportData'
import ProductsLayout from '@/screens/Product'

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path="/" element={<BaseLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/loading" element={<LoadingPage />} />
            <Route path="qsf/*" element={<QSFLayout />} />
            <Route path="qsf" element={<Navigate to={'/qsf/inspection'} />} />
            <Route path="system-configure/*" element={<SystemConfigure />} />
            <Route path="pbf/*" element={<PBFLayout />} />
            <Route path="tasks/*" element={<TasksLayout />} />
            <Route path="products/*" element={<ProductsLayout />} />
            <Route path="user-profile" element={<UserProfile />} />
            <Route path="liveboard/*" element={<LiveboardLayout />} />
          </Route>
        </Route>
        <Route path="export-data/*" element={<ExportDataLayout />} />
        <Route path="auth/*" element={<AuthLayout />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  )
}
